

function headerPin() {

    // Get the sidebar links and sections
    const sidebarLinks = document.querySelectorAll('.faqs__sidebar a');
    const sections = document.querySelectorAll('.faqsSection');

    if (!sidebarLinks.length || !sections.length) {
        return;
    }

    // Create a new Intersection Observer instance
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const targetId = entry.target.getAttribute('id');
                const targetLink = document.querySelector(`.faqs__sidebar a[href="#${targetId}"]`);

                // Remove active class from all sidebar links
                sidebarLinks.forEach((link) => {
                    link.parentElement.classList.remove('active');
                });

                // Add active class to the target link
                if (targetLink) {
                    targetLink.parentElement.classList.add('active');
                }
            }
        });
    }, { threshold: 0.4 });

    // Observe each section
    sections.forEach((section) => {
        observer.observe(section);
    });

}

/**
 * Function to run when this module is called from site.js
 */
const init = () => {
    headerPin();
};

export default init;
